import { SET_SUV_LIST } from '../../../../../frontend/suv/modules/RiskMonitor/consts/action-types';

export enum PREFERENCE {
  ID = 'id',
  SUV_SIDEBAR_OPEN = 'suv_sidebar_open',
  SUV_SELECTED_GROUP = 'suv_selected_group',
  SUV_MAP_STYLE = 'map_style',
  SOUND = 'notification_sound',
  LOCALE = 'locale',
  TEMPERATURE_UNITS = 'temperature_units',
  DISTANCE_UNIT = 'distance_unit',
  TIMEZONE = 'timezone',
  DEFAULT_APP = 'default_app',
  ASSET_MANAGER_DEFAULT_FILTER_ID = 'asset_manager_default_filter_id',
  TIME_FORMAT = 'time_format',
  THEME_MODE = 'theme_mode',
  DEFAULT_DASHBOARD_ID = 'default_dashboard_id',
  MAP_VIEW_MODE = 'map_view_mode'
}

type PreferencesActions = { [key in PREFERENCE]: string };

export const PREFERENCES_ACTIONS = {
  [PREFERENCE.SUV_SIDEBAR_OPEN]: SET_SUV_LIST,
  [PREFERENCE.SUV_SELECTED_GROUP]: 'SET_LIST_OPENED_GROUP',
  [PREFERENCE.SUV_MAP_STYLE]: 'CHANGE_MAP_STYLE',
} as PreferencesActions;